import CertificatePreview from './src/main';

/* istanbul ignore next */
CertificatePreview.install = function(Vue) {
  Vue.component(CertificatePreview.name, CertificatePreview);
};

export default CertificatePreview;
